import {useEffect} from 'react';
import {Link, useLocation, useNavigate} from 'react-router';

import {AccountTypeT} from '@/lib/types/authentication.types';

import RegistrationForm from '@/pages/(public)/pages/register/components/registrationForm';

import {useAuth} from '@/providers/components/authProvider';

function RegistrationPage() {
  const navigate = useNavigate();
  const accountType: AccountTypeT = useLocation()?.state?.accountType ?? 'speculator';
  const {
    handleSignOut,
    userAccounts: {verification},
    isAuthenticated,
    authenticating,
    isAdministrator,
  } = useAuth();

  // Reactivity
  useEffect(() => {
    // Wait for the authentication to complete
    if (authenticating) return;

    // If the user is not authenticated, they should not be on this page
    if (!isAuthenticated) navigate('/');

    // We must have a user and we'll need to wait for the user's verification record
    if (!verification || verification.is_new_user) return;

    // The user is authenticated and is not a new user, redirect to the appropriate dashboard
    if (isAdministrator) {
      navigate('/admin/dashboard');
      return;
    }

    navigate('/speculator/dashboard');
  }, [navigate, verification, isAuthenticated, authenticating, isAdministrator]);

  if (authenticating || !isAuthenticated || !verification) return null;

  return (
    <div className="container">
      <div className="authentication authentication-basic h-full items-center text-defaultsize text-defaulttextcolor">
        <div className="mx-auto">
          <div className="my-[2.5rem] flex justify-center">
            <img src={'/images/logo/logo.png'} alt="logo" className="desktop-logo max-w-[150px]" />
            <img src={'/images/logo/logo.png'} alt="logo" className="desktop-dark max-w-[150px]" />
          </div>
          <div className="box">
            <div className="box-body !p-[1rem]">
              <p className="h5 mb-2 text-center font-semibold capitalize">{accountType} Registration</p>
              <p className="mb-4 text-center font-normal text-[#8c9097] opacity-[0.7] dark:text-white/50">
                We just need you to fill out a few details to get started
              </p>
              <RegistrationForm accountType={accountType} />
              <p className="mt-4 text-center text-[0.75rem] text-[#8c9097] dark:text-white/50">
                Wrong account?{' '}
                <button onClick={handleSignOut} className="text-primary">
                  Sign Out
                </button>
              </p>
            </div>
          </div>
          <div className="mb-4 flex items-center justify-center gap-1">
            <Link to="https://tos.tnc.exchange/" className="text-success" target="_blank" rel="noreferrer">
              <u>Terms &amp; Conditions</u>
            </Link>
            <span>|</span>
            <Link to="https://pp.tnc.exchange/" className="text-success" target="_blank" rel="noreferrer">
              <u>Privacy Policy</u>
            </Link>
          </div>
          <small className="my-5 block text-center text-gray-800/70 dark:text-white/70">
            By creating an account you agree to our
            <br />
            Terms &amp; Conditions and Privacy Policy
          </small>
        </div>
      </div>
    </div>
  );
}

export default RegistrationPage;
